import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material'
import { Box, Checkbox, FormControlLabel, FormGroup, Grid } from '@mui/material'
import React, { ReactNode } from 'react'
import { Control, Controller } from 'react-hook-form'

interface Sizing {
  xs: number
  sm: number
  md: number
  lg: number
  xl: number
}

interface IFormCheckBox {
  sizing: Sizing
  label: ReactNode | string
  name: string
  control: Control<any, object>
  onChange?: (e: any) => void
  disabled?: boolean
}

const FormCheckBox: React.FC<IFormCheckBox> = ({ sizing, label, name, control, onChange = () => {}, disabled = false }) => {
  return (
    <Grid item xs={sizing.xs} sm={sizing.sm} md={sizing.md} lg={sizing.lg} xl={sizing.xl}>
      <FormGroup sx={{ marginLeft: '0.5rem' }}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <FormControlLabel
              disabled={disabled}
              sx={{
                '& .MuiFormControlLabel-label': {
                  fontFamily: 'Nunito !important',
                  fontWeight: '400 !important',
                  fontSize: '1rem !important',
                  lineHeight: '1.5rem !important',
                },
              }}
              label={
                <Box
                  sx={{
                    fontSize: '15px',
                    lineHeight: '24px',
                    fontWeight: '400',
                    opacity: 0.75,
                    margin: '12px 0',
                    color: '#0f0f1e',
                  }}
                >
                  {label}
                </Box>
              }
              control={
                <Checkbox
                  icon={<RadioButtonUnchecked sx={{ opacity: 0.6 }} />}
                  checkedIcon={<RadioButtonChecked color='primary' />}
                  checked={field.value}
                  disabled={disabled}
                  onChange={(e) => {
                    field.onChange(e.target.checked)
                    onChange(e)
                  }}
                />
              }
            />
          )}
        />
      </FormGroup>
    </Grid>
  )
}

export default FormCheckBox

/*
Exemplo de uso:

  <Form.Checkbox
    label='Nome Fantasia'
    sizing={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
    name="tradingName"
    control={control}
  />
*/
